module.exports = __webpack_public_path__ + "static/media/logo.484d942a.png";